import {
  AiCreditBalanceLevel,
  USAGE_ALERT_THRESHOLD_PERCENT,
} from "@repo/app-types/entities/creditUsage";
import { InfoBanner } from "@repo/ui/InfoBanner/infoBanner";
import { Link } from "@repo/ui/Link/index";
import { SimpleModalVariant } from "@repo/ui/Modal/modal";
import { DateTime } from "luxon";
import type { FC } from "react";
import {
  AI_CREDITS_SALES_HREF,
  type AiCreditsWarningLevel,
} from "../../billing/aiCreditsLimitBanner.js";

interface AiCreditsBalanceBannerProps {
  level: AiCreditsWarningLevel;
  /** Exclusive ISO end of the current period. */
  resetsAt: string;
}

/** The billing page's notice that AI credits are low or used up. */
export const AiCreditsBalanceBanner: FC<AiCreditsBalanceBannerProps> = (
  props,
) => {
  const { level, resetsAt } = props;
  const resetDate = DateTime.fromISO(resetsAt, { zone: "utc" }).toFormat(
    "MMMM d",
  );
  const contactSales = (
    <>
      To add credits, contact{" "}
      <Link href={AI_CREDITS_SALES_HREF}>sales@alpharun.com</Link>.
    </>
  );

  switch (level) {
    case AiCreditBalanceLevel.RunningLow:
      return (
        <InfoBanner
          title="AI credits are running low"
          description={
            <>
              You’ve used over {USAGE_ALERT_THRESHOLD_PERCENT}% of your AI
              credits. Some features may be paused if credits run out before
              they reset on {resetDate}. {contactSales}
            </>
          }
          variant="CAUTION"
        />
      );
    case AiCreditBalanceLevel.Exhausted:
      return (
        <InfoBanner
          title="AI credits are used up"
          description={
            <>
              You’ve used all of your AI credits. Some features may be paused
              until credits reset on {resetDate}. {contactSales}
            </>
          }
          variant={SimpleModalVariant.Warning}
        />
      );
  }
};
